import { Formik } from 'formik';
import React from 'react';
import { Form, Table } from 'react-bootstrap';
import { createUseStyles } from 'react-jss';
import * as yup from 'yup';
import es from '../../../../yup-es';

yup.setLocale(es);

const useStyles = createUseStyles({
  checkContainer: {
    textAlign: 'center',
    cursor: 'pointer',
  },
  reqFeedback: {
    marginTop: 0,
    display: 'block',
    visibility: 'hidden',
    fontSize: '75%',
  },
});
const Requisitos = ({ requisitosConvocatoria = [], requisitosPuesto = [], onConfirmar = null }) => {
  const classes = useStyles();
  const requisitos = [...requisitosConvocatoria, ...requisitosPuesto];
  const handleSubmit = (values) => {
    onConfirmar?.(values);
  };

  const customSchema = requisitos.reduce(
    (acum, cur) => {
      const field = cur.idRequisitoPuesto
        ? `req_puesto_${cur.idRequisitoPuesto}`
        : `req_convocatoria_${cur.idRequisitoLlamadoConcurso}`;
      return {
        schema: {
          ...acum.schema,
          [field]: cur.requerido
            ? yup.boolean().oneOf([true], 'Debe cumplir con este requisito') //obliga a que sea true
            : yup.boolean().required(), //required, pero siempre es false o true
        },
        initial: {
          ...acum.initial,
          [field]: false,
        },
      };
    },
    { schema: {}, initial: {} },
  );

  const schema = yup.object(customSchema.schema);

  return (
    <Formik
      validationSchema={schema}
      initialValues={customSchema.initial}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={handleSubmit}>
      {(formik) => (
        <Form id="formRequisitos" noValidate onSubmit={formik.handleSubmit}>
          {requisitos.length > 0 && (
            <Table striped bordered size="sm">
              <thead>
                <tr>
                  <th style={{ width: '95%' }}>Requisito</th>
                  <th style={{ width: '5%' }}>¿Cumple?</th>
                </tr>
              </thead>
              <tbody>
                {requisitos.map((req, idx) => {
                  const field = req.idRequisitoPuesto
                    ? `req_puesto_${req.idRequisitoPuesto}`
                    : `req_convocatoria_${req.idRequisitoLlamadoConcurso}`;

                  return (
                    <Form.Group as="tr" key={idx}>
                      <td>
                        {req.nombre}{' '}
                        <i className="pointer fa fa-question-circle-o" title={req.descripcion}></i>
                        <Form.Control.Feedback
                          className={classes.reqFeedback}
                          type="invalid"
                          style={{ visibility: formik.errors[field] ? 'visible' : 'hidden' }}>
                          {formik.errors[field]}&nbsp;
                        </Form.Control.Feedback>
                      </td>
                      <td
                        className={classes.checkContainer}
                        onClick={() => formik.setFieldValue(field, !formik.values[field])}>
                        <Form.Check
                          type="checkbox"
                          label=""
                          name={field}
                          checked={formik.values[field]}
                          value={formik.values[field]}
                          onBlur={formik.handleBlur}
                          isInvalid={formik.touched[field] && !!formik.errors[field]}
                          onChange={formik.handleChange}
                        />
                      </td>
                    </Form.Group>
                  );
                })}
              </tbody>
            </Table>
          )}
        </Form>
      )}
    </Formik>
  );
};

export default Requisitos;
